module.exports = __webpack_public_path__ + "assets/img/1.eac8a009.png";